<template>
  <div class="cp-win mobile">
    <div class="prize"></div>
    <div v-if="data.length" class="prize-wrapper" :class="[bigPrize ? 'prize-wrapper-3' : '']" ref="wrapper">
      <Prize
        v-for="(prize, index) in data"
        :key="index"
        :prize="prize.icon"
        :name="prize.title"
        :ref="`prize-${index + 1}`"
        :class="[bigPrize ? `prize prize-31 prize-3-${index + (index > 0 ? 2 : 1)}` : `prize prize-${index + 1}`]"
      >
      </Prize>
    </div>
    <div v-show="showButtons" class="button" @click="showShare"></div>
    <div v-show="showButtons" class="button draw" @click="lotto"></div>
    <div v-show="showButtons" class="desc">召集助力，增加更多十连次数！</div>
    <div v-show="showButtons" class="desc times">还能抽<span class="emphasis">{{chance}}</span>次</div>
    <Close is-mobile @close="handleClose" class="close"></Close>
  </div>
</template>

<script>
// 移动端头部
import { isMobile, setStore, getParameterByName } from '~/tools/utils'
import Close from '~/components/Close/close.vue';
import api from '~/api/api'
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import Prize from "~/components/Prize/index.vue";
import { mapState } from "vuex";
import Alert from "~/components/Alert";

export default {
  name: 'Info',
  components: {Close, Prize},
  props: {
    win: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isMobile: isMobile(),
      loading: false,
      data: [],
      showButtons: false,
      ingame: getParameterByName("ingame"),
      star: getParameterByName("star")
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      chance: state => state.chance,
      prizeList: state => state.prizeList,
      modal: state => state.modal
    }),
    hasChance() {
      let hasChance = !this.prizeList || !this.prizeList.list || this.prizeList.list.length < 180
      return hasChance
    },
    bigPrize() {
      return this.data.length && this.data.some(x => x.icon === 31)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.data = this.modal.win.sort((a, b) => b.icon - a.icon)
    })
    setTimeout(() => {
      this.showButtons = true
    }, 1596)
  },
  beforeDestroy() {
    this.data = []
  },
  methods: {
    lotto() {
      if(!this.hasChance) {
        // 10次机会用完
        store.commit(types.SHOW_MODAL, {type: 'noChance'})
        return
      }
      if(!this.chance) {
        // Alert("您已没有抽奖次数了")
        store.commit(types.SHOW_MODAL, {type: 'times'});
        return
      }
      if(this.loading) {
        return
      }
      store.commit(types.SHOW_LOADING, true)
      this.loading = true;
      let lottoRes;
      api.lotto().then(res => {
        if(res.status === 1) {
          lottoRes = res;
          this.data = [];
          store.commit(types.UPDATE_CHANCE, this.chance - 1);
          Array.from(Array(10).keys()).forEach(x => {
            if(res.info.item_detail.some(item => item.icon === 31)) {
              this.$refs[`prize-${x + 1}`].className = `prize prize-31`
            } else {
              this.$refs[`prize-${x + 1}`].className = `prize`
            }
          })
          setTimeout(() => {
            res.info.item_detail = res.info.item_detail.sort((a, b) => b.icon - a.icon)
            res.info.item_detail.forEach(x => this.data.push(x));
            Array.from(Array(10).keys()).forEach(x => {
              if(res.info.item_detail.some(item => item.icon === 31)) {
                this.$refs[`prize-${x + 1}`].className = `prize prize-31 prize-${x + (x > 0 ? 2 : 1)}`
              } else {
                this.$refs[`prize-${x + 1}`].className = `prize prize-${x + 1}`
              }
            })
          }, 0);
          this.showButtons = false;
          setTimeout(() => {
            this.showButtons = true
          }, 1596)
          return api.getPrizeList();
        }
      }).then(res => {
        if(res && res.status === 1) {
          let prizeList = {
            list: res.list.reduce((a, b) => a.concat(b), [])
          }
          if(lottoRes.realinfo && lottoRes.realinfo.item_name) {
            prizeList = Object.assign({}, prizeList, {
              realinfo: lottoRes.realinfo.item_name
            })
          }
          store.commit(types.UPDATE_PRIZE, Object.assign({}, this.prizeList, prizeList));
        }
        this.$nextTick(() => {
          // TODO 根据结果判断是否展示实物奖
          if(lottoRes.realinfo && lottoRes.realinfo.item_name) {
            setTimeout(() => {
              store.commit(types.SHOW_MODAL2, {type: 'material', material: lottoRes.realinfo.item_name})
            }, 1896);
          }
        })

        store.commit(types.SHOW_LOADING, false)
        this.loading = false;
      }).catch((e) => {
        store.commit(types.SHOW_LOADING, false)
        this.loading = false;
      })
    },
    showShare() {
      if(!this.hasChance) {
        // 10次机会用完
        store.commit(types.SHOW_MODAL, {type: 'noChance'})
        return
      }
      let url = `${this.userInfo.shareinfo.nickname}邀请你助力《原始征途》嘉年华至尊百连抽，5000升级宝石免费送：`
      store.commit(types.SHOW_MODAL, {type: 'copy', copy: url + window.location.origin + `/act/blc_carnival2024/#/share?fid=${this.userInfo.shareinfo.userid}`})
      // if(this.ingame) {
      // } else {
      //   store.commit(types.SHOW_MODAL, {type: 'share'});
      // }
    },
    onSelect(data_id) {
      // console.log(data_id)
      this.data_id = data_id
      setStore('data_id', data_id)
    },
    goToQuestion() {
      if(this.checked) {
        location.href = ''
      }
    },
    handleClose() {
      store.commit(types.HIDE_MODAL);
    }
  }
};
</script>

<style lang="stylus" scoped>
  .cp-win
    position absolute
    width 6.66rem
    height 9.63rem
    background-image url('./images/prize.png')
    background-size: 6.66rem 8.93rem;
    background-repeat: no-repeat;
    background-position 0 0
    .desc
      position absolute
      top 7.75rem
      left 0.95rem
      font-size 0.24rem
      line-height 0.24rem
      color #000
      font-weight bold
      animation fadeIn 0.3s ease
      &.times
        left: 4.38rem;
        width: 1.66rem;
        text-align center
        .emphasis
          color: #b42d00
          margin: 0 0.07rem
          display inline-block
    .prize-wrapper
      margin 2.1rem 0 0 0.48rem
      position relative
      display flex
      flex-wrap wrap
      &-3
        margin-top 1.31rem
      .prize
        position absolute
        left 2.36rem
        top 0.85rem
        opacity 0
        &-31
          top 1.8rem
        &-3-1
          z-index 11
          animation prize-3-1 0.228s linear forwards
        &-3-3
          z-index 9
          animation prize-3-3 0.078s linear 0.228s forwards
        &-3-4
          z-index 8
          animation prize-3-4 0.132s linear 0.36s forwards
        &-3-5
          z-index 7
          animation prize-3-5 0.228s linear 0.438s forwards
        &-3-6
          z-index 6
          animation prize-3-6 0.228s linear 0.57s forwards
        &-3-7
          z-index 5
          animation prize-3-7 0.132s linear 0.798s forwards
        &-3-8
          z-index 4
          animation prize-3-8 0.078s linear 1.026s forwards
        &-3-9
          z-index 3
          animation prize-3-9 0.132s linear 1.158s forwards
        &-3-10
          z-index 2
          animation prize-3-10 0.228s linear 1.236s forwards
        &-3-11
          z-index 1
          animation prize-3-11 0.228s linear 1.368s forwards
        &-1
          z-index 11
          animation prize-1 0.228s linear forwards
        &-2
          z-index 10
          animation prize-2 0.132s linear 0.228s forwards
        &-3
          z-index 9
          animation prize-3 0.078s linear 0.36s forwards
        &-4
          z-index 8
          animation prize-4 0.132s linear 0.438s forwards
        &-5
          z-index 7
          animation prize-5 0.228s linear 0.57s forwards
        &-6
          z-index 6
          animation prize-6 0.228s linear 0.798s forwards
        &-7
          z-index 5
          animation prize-7 0.132s linear 1.026s forwards
        &-8
          z-index 4
          animation prize-8 0.078s linear 1.158s forwards
        &-9
          z-index 3
          animation prize-9 0.132s linear 1.236s forwards
        &-10
          z-index 2
          animation prize-10 0.228s linear 1.368s forwards
    .button
      width 2.32rem
      height 0.86rem
      background-size: 100% 100%;
      background-image url('./images/go.png')
      background-repeat: no-repeat;
      position absolute
      top 6.68rem
      left 0.78rem
      animation fadeIn 0.3s ease
      &.draw
        left 3.56rem
        width 2.34rem
        height 0.89rem
        background-image url('./images/continue.png')

@keyframes fadeIn {
  from {
    opacity 0
  }
  to {
    opacity: 1
  }
}
@keyframes prize-1 {
  to {
    opacity: 1
    transform: translateX(-2.36rem) translateY(-0.85rem)
  }
}
@keyframes prize-2 {
  to {
    opacity: 1
    transform: translateX(-1.18rem) translateY(-0.85rem)
  }
}
@keyframes prize-3 {
  to {
    opacity: 1
    transform: translateX(0) translateY(-0.85rem)
  }
}
@keyframes prize-4 {
  to {
    opacity: 1
    transform: translateX(1.18rem) translateY(-0.85rem)
  }
}
@keyframes prize-5 {
  to {
    opacity: 1
    transform: translateX(2.36rem) translateY(-0.85rem)
  }
}
@keyframes prize-6 {
  to {
    opacity: 1
    transform: translateX(-2.36rem) translateY(0.85rem)
  }
}
@keyframes prize-7 {
  to {
    opacity: 1
    transform: translateX(-1.18rem) translateY(0.85rem)
  }
}
@keyframes prize-8 {
  to {
    opacity: 1
    transform: translateX(0) translateY(0.85rem)
  }
}
@keyframes prize-9 {
  to {
    opacity: 1
    transform: translateX(1.18rem) translateY(0.85rem)
  }
}
@keyframes prize-10 {
  to {
    opacity: 1
    transform: translateX(2.36rem) translateY(0.85rem)
  }
}

@keyframes prize-3-1 {
  to {
    opacity: 1
    transform: translateX(-2.36rem) translateY(-1.8rem)
  }
}
@keyframes prize-3-3 {
  to {
    opacity: 1
    transform: translateX(0) translateY(-1.8rem)
  }
}
@keyframes prize-3-4 {
  to {
    opacity: 1
    transform: translateX(1.18rem) translateY(-1.8rem)
  }
}
@keyframes prize-3-5 {
  to {
    opacity: 1
    transform: translateX(2.36rem) translateY(-1.8rem)
  }
}
@keyframes prize-3-6 {
  to {
    opacity: 1
    transform: translateX(-2.36rem) translateY(0)
  }
}
@keyframes prize-3-7 {
  to {
    opacity: 1
    transform: translateX(-1.18rem) translateY(0)
  }
}
@keyframes prize-3-8 {
  to {
    opacity: 1
    transform: translateX(0) translateY(0)
  }
}
@keyframes prize-3-9 {
  to {
    opacity: 1
    transform: translateX(1.18rem) translateY(0)
  }
}
@keyframes prize-3-10 {
  to {
    opacity: 1
    transform: translateX(2.36rem) translateY(0)
  }
}

@keyframes prize-3-11 {
  to {
    opacity: 1
    transform: translateX(-2.36rem) translateY(1.8rem)
  }
}
</style>
